import React, { useState, useContext } from 'react';
import '../../App.css';
import { SiteContext } from '../../App';
import DropDownSection from './DropDownSection/DropDownSection';


const PageView = ({ model, assets }) => {
    const [error, setError] = useState(null);

    if (error) return <div>{error}</div>;

    return (
        <div className="container">

            <DropDownSection model={model} assets={assets}/>

        </div>
    );
};

export default PageView;
